import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { AnimateIn, SectionRow } from '../components/Layout';
import { researchContent } from '../data/mock';

const ResearchPage = () => {
  return (
    <div>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="page-hero-content">
          <div className="inner">
            <AnimateIn>
              <h1 className="hero-headline" style={{ marginBottom: '24px' }}>
                {researchContent.heroTitle}
              </h1>
            </AnimateIn>
            <AnimateIn delay={100}>
              <p className="hero-desc" style={{ maxWidth: '540px' }}>
                {researchContent.heroDesc}
              </p>
            </AnimateIn>
          </div>
        </div>
      </section>

      <SectionRow number="One" label="The Constraint" />

      {/* Labeller's Ceiling */}
      <section className="sec-light sec-pad-lg">
        <div className="inner">
          <div className="grid-2">
            <div>
              <AnimateIn>
                <h2 className="heading-lg">{researchContent.ceiling.heading}</h2>
              </AnimateIn>
            </div>
            <div>
              <AnimateIn delay={100}>
                <p className="body-text" style={{ marginBottom: '28px' }}>
                  {researchContent.ceiling.desc}
                </p>
              </AnimateIn>
              <AnimateIn delay={200}>
                <p className="body-text" style={{ 
                  fontFamily: "'Gambarino', Georgia, serif",
                  fontSize: '18px',
                  lineHeight: '1.5',
                  color: '#3E4032',
                  fontStyle: 'italic'
                }}>
                  {researchContent.ceiling.insight}
                </p>
              </AnimateIn>
            </div>
          </div>
        </div>
      </section>

      <SectionRow number="Two" label="Three Categories" linkText="Framework" linkHref="/framework" />

      {/* Categories Comparison */}
      <section className="sec-white sec-pad-lg">
        <div className="inner">
          {/* Conceptual Image 2 - Reaching Hands */}
          <AnimateIn>
            <div style={{
              width: '100%',
              maxWidth: '700px',
              margin: '0 auto 80px',
              borderRadius: '4px',
              overflow: 'hidden'
            }}>
              <img
                src="https://customer-assets.emergentagent.com/job_subsense-lab/artifacts/gm751veo_8b44e22bbafd4fa20434b014079364d6.jpg"
                alt="Knowledge reaching across domains"
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  opacity: 0.95
                }}
              />
            </div>
          </AnimateIn>
          
          <div className="compare-grid">
            {researchContent.categories.map((cat, i) => (
              <AnimateIn key={cat.title} delay={i * 120}>
                <div className={`compare-col ${cat.highlighted ? 'highlighted' : ''}`}>
                  <div className="compare-title">{cat.title}</div>
                  <div className="compare-desc">{cat.desc}</div>
                  <div className="compare-props">
                    {cat.props.map((prop) => (
                      <div key={prop.label} className="compare-prop">
                        <span className="compare-prop-label">{prop.label}</span>
                        <span className="compare-prop-value">{prop.value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </AnimateIn>
            ))}
          </div>
        </div>
      </section>

      {/* Key Insight — Integrated into Light Section */}
      <section className="sec-light sec-pad-lg" style={{ paddingTop: '80px' }}>
        <div className="inner">
          {/* Conceptual Image 1 - Motion Portrait */}
          <AnimateIn>
            <div style={{
              width: '100%',
              maxWidth: '600px',
              margin: '0 auto 80px',
              borderRadius: '4px',
              overflow: 'hidden'
            }}>
              <img
                src="https://customer-assets.emergentagent.com/job_subsense-lab/artifacts/btexmnei_6bc4cab844601a3235effad84d4d9bee.jpg"
                alt="Sublinguistic Intelligence"
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  opacity: 0.95
                }}
              />
            </div>
          </AnimateIn>
          
          <AnimateIn>
            <div style={{
              maxWidth: '1000px',
              margin: '0 auto',
              padding: '60px 0',
              borderTop: '1px solid rgba(16,16,16,0.1)',
              borderBottom: '1px solid rgba(16,16,16,0.1)'
            }}>
              <p style={{
                fontFamily: "'Gambarino', Georgia, serif",
                fontSize: 'clamp(24px, 3vw, 40px)',
                lineHeight: '1.3',
                color: '#3E4032',
                textAlign: 'center',
                fontStyle: 'italic'
              }}>
                {researchContent.keyInsight}
              </p>
            </div>
          </AnimateIn>
        </div>
      </section>
    </div>
  );
};

export default ResearchPage;
